export const appendixCurrencyCutoffTime = `
<p><strong>Domestic payment cut-off times</strong></p>
<p style="border-bottom: 2px solid #006a4d; display : flex;">
<img src='${process.env.PUBLIC_URL}/images/9/3/2/Left.png' style='width:50%' alt="domestic payment"/>
<img src='${process.env.PUBLIC_URL}/images/9/3/2/Right.png' style='width:50%' alt="domestic payment"/>
</p>
<p><img src='${process.env.PUBLIC_URL}/images/9/3/2/OutboundPayment.png' style="width: 100%;" alt="Outbound payment"></p>
<p><img src='${process.env.PUBLIC_URL}/images/9/3/2/ExampleOutbound.png' style="width: 100%;" alt="Outbound payment example"></p>
`;


// WEBPACK FOOTER //
// ./src/components/content/appendices/2-currencyCutoffTime.ts